<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content">
    <div class="title-box">
      <span class="title">{{ "PERMISSION_MANAGEMENT" | translate }}</span>
      <button
        nz-button
        nzType="primary"
        (click)="isVisible = true"
        class="margin-left-auto add"
      >
        <bcsc-digi-icon type="digi-big-plus"></bcsc-digi-icon>
        <span>{{ "ADD" | translate }}</span>
      </button>
    </div>
    <div class="container">
      <nz-table
        #basicTable
        [nzData]="dataSource"
        [nzFrontPagination]="false"
        [nzServerRender]="true"
        [nzScroll]="{ y: 'calc(100vh - 261px)' }"
        [nzWidthConfig]="widthConfig"
      >
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.name | translate }}</th>
            <th nzRight>{{ "OPERATIONS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-data [ngForOf]="basicTable.data">
            <tr>
              <ng-container *ngFor="let col of columns; let index = index">
                <td *ngIf="index !== 0">
                  <ng-container *ngIf="col.key !== 'icon'">
                    {{ data[col.key] }}
                  </ng-container>
                  <ng-container *ngIf="col.key === 'icon' && data[col.key]">
                    <bcsc-digi-icon
                      [type]="'digi-' + data[col.key]"
                    ></bcsc-digi-icon>
                  </ng-container>
                </td>
                <td
                  *ngIf="index === 0"
                  [nzShowExpand]="
                    !!(data.subPermissionList && data.subPermissionList.length)
                  "
                  [(nzExpand)]="data.expand"
                  (nzExpandChange)="collapse()"
                >
                  {{ data[col.key] ? data[col.key] : "-" }}
                </td>
              </ng-container>
              <td class="opreations" nzRight>
                <i
                  nz-icon
                  nzType="edit"
                  nzTheme="outline"
                  (click)="onEditPermission(data)"
                  nz-tooltip
                  [nzTooltipTitle]="'EDIT' | translate"
                ></i>
                <i
                  nz-icon
                  nzType="delete"
                  nzTheme="outline"
                  nz-popconfirm
                  [nzPopconfirmTitle]="
                    'DELETE_PERMISSION_POP_CONFIRM'
                      | translate : { name: data.name }
                  "
                  (nzOnConfirm)="onDelete(data)"
                  nzPopconfirmPlacement="topLeft"
                  nz-tooltip
                  [nzTooltipTitle]="'DELETE' | translate"
                  nzTooltipTitle="Delete"
                ></i>
                <i
                  nz-icon
                  nzType="plus-square"
                  nzTheme="outline"
                  (click)="onAddSubPermission(data)"
                  nz-tooltip
                  [nzTooltipTitle]="'PERMISSION_ADD_CHILD' | translate"
                  nzTooltipTitle="Add Child"
                ></i>
              </td>
            </tr>
            <ng-container *ngIf="data.expand">
              <tr *ngFor="let childData of data.subPermissionList">
                <td *ngFor="let col of columns" class="child-td">
                  <ng-container *ngIf="col.key !== 'icon'">
                    {{ childData[col.key] ? childData[col.key] : "-" }}
                  </ng-container>
                  <ng-container
                    *ngIf="col.key === 'icon' && childData[col.key]"
                  >
                    <bcsc-digi-icon
                      [type]="'digi-' + childData[col.key]"
                    ></bcsc-digi-icon>
                  </ng-container>
                </td>
                <td class="opreations" nzRight>
                  <i
                    nz-icon
                    nzType="edit"
                    nzTheme="outline"
                    (click)="onEditPermission(childData)"
                    nz-tooltip
                    [nzTooltipTitle]="'EDIT' | translate"
                  ></i>
                  <i
                    nz-icon
                    nzType="delete"
                    nzTheme="outline"
                    nz-popconfirm
                    [nzPopconfirmTitle]="
                      'DELETE_PERMISSION_POP_CONFIRM'
                        | translate : { name: data.title || data.name }
                    "
                    (nzOnConfirm)="onDelete(childData)"
                    nzPopconfirmPlacement="topLeft"
                    nz-tooltip
                    [nzTooltipTitle]="'DELETE' | translate"
                  ></i>
                  <i
                    nz-icon
                    nzType="PlusSquare"
                    nzTheme="outline"
                    (click)="onAddSubPermission(childData)"
                    nz-tooltip
                    [nzTooltipTitle]="'PERMISSION_ADD_CHILD' | translate"
                  ></i>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </tbody>
      </nz-table>
    </div>
    <nz-modal
      [(nzVisible)]="isVisible"
      [nzTitle]="'NEW_ADD_PERMISSION' | translate"
      (nzOnCancel)="onCancel()"
      (nzOnOk)="onSave()"
      nzWidth="808px"
    >
      <ng-container *nzModalContent>
        <form
          nz-form
          [formGroup]="validateModuleForm"
          (ngSubmit)="isVisible = false"
        >
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzRequired nzFor="name">{{
              "PERMISSION_NAME" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PERMISSION_NAME' | translate }
              "
            >
              <input
                nz-input
                formControlName="name"
                id="name"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'PERMISSION_NAME' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="title" nzRequired>{{
              "PERMISSION_TITLE_EN" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PERMISSION_TITLE_EN' | translate }
              "
            >
              <input
                nz-input
                formControlName="title"
                id="title"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'PERMISSION_TITLE_EN' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzRequired nzFor="titleEn">{{
              "PERMISSION_TITLE_ZH" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PERMISSION_TITLE_ZH' | translate }
              "
            >
              <input
                nz-input
                formControlName="titleEn"
                id="titleEn"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'PERMISSION_TITLE_ZH' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzRequired nzFor="url">{{
              "PERMISSION_URL" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PERMISSION_URL' | translate }
              "
            >
              <input
                nz-input
                formControlName="url"
                id="url"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'PERMISSION_URL' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzRequired nzFor="icon">{{
              "PERMISSION_ICON" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_SELECT'
                  | translate : { name: 'PERMISSION_ICON' | translate }
              "
            >
              <nz-select
                formControlName="icon"
                id="icon"
                [nzPlaceHolder]="
                  'PLACEHOLDER_PLEASE_SELECT'
                    | translate : { name: 'PERMISSION_ICON' | translate }
                "
              >
                <nz-option
                  *ngFor="let icon of iconList"
                  [nzValue]="icon"
                  [nzLabel]="icon"
                  nzCustomContent
                >
                  <bcsc-digi-icon [type]="'digi' + icon"></bcsc-digi-icon>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="5"
              [nzXs]="24"
              nzRequired
              nzFor="permissionCode"
              >{{ "PERMISSION_CODE" | translate }}</nz-form-label
            >
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'PERMISSION_CODE' | translate }
              "
            >
              <input
                nz-input
                formControlName="permissionCode"
                id="permissionCode"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'PERMISSION_CODE' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="5"
              [nzXs]="24"
              nzRequired
              nzFor="menuOrder"
              >{{ "MENU_ORDER" | translate }}</nz-form-label
            >
            <nz-form-control
              [nzSm]="19"
              [nzXs]="24"
              [nzErrorTip]="'PLEASE_INPUT_A_NUMBER' | translate"
            >
              <input
                nz-input
                formControlName="menuOrder"
                id="menuOrder"
                [placeholder]="
                  'PLACEHOLDER_PLEASE_INPUT'
                    | translate : { name: 'MENU_ORDER' | translate }
                "
              />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="5"
              [nzXs]="24"
              nzRequired
              nzFor="menuHidden"
              >{{ "MENU_HIDDEN" | translate }}</nz-form-label
            >
            <nz-form-control [nzSm]="19" [nzXs]="24">
              <nz-radio-group formControlName="menuHidden">
                <label nz-radio nzValue="Y">{{ "YES" | translate }}</label>
                <label nz-radio nzValue="N">{{ "NO" | translate }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="5" [nzXs]="24" nzRequired nzFor="type">{{
              "PERMISSION_TYPE" | translate
            }}</nz-form-label>
            <nz-form-control [nzSm]="19" [nzXs]="24">
              <nz-radio-group formControlName="type">
                <label nz-radio nzValue="MENU">{{ "MENU" | translate }}</label>
                <label nz-radio nzValue="BUTTON">{{
                  "BUTTON" | translate
                }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </nz-modal>
  </div>
</nz-spin>
